import React, { useState, useEffect } from "react";
import s from "./Promo.module.scss";
import plus from "../../Images/plus.png";
import minus from "../../Images/minus.png";

interface PromoCodeProps {
  id?: number;
  name: string;
  discount: number;
}

interface PromoCodeStrings {
  id?: number;
  name: string;
  discount: string;
}

interface PromoCodeData {
  id?: number;
  name: string;
  discount: number;
  sorter: number;
}

interface PromoProps {
  editablePromocodes: PromoCodeProps[] | null;
  editablePromocodesId: (number | undefined)[] | undefined;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

export const Promo: React.FC<PromoProps> = ({ editablePromocodes, editablePromocodesId, setFormData }) => {
  const initialPromoCodes = editablePromocodes?.map((promo) => ({
    name: promo.name,
    discount: `${promo.discount}%`
  })) || [];

  const [promoCodes, setPromoCodes] = useState<PromoCodeStrings[]>(initialPromoCodes);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showPromoCodes, setShowPromoCodes] = useState(initialPromoCodes.length > 0);
  // const [width] = useWindowSize();

  useEffect(() => {
    setFormData((prev: any) => ({
      ...prev,
      promocodes: promoCodes
        .filter(promo => promo.name.trim() !== "" && promo.discount !== "0%")
        .map((promo, index) => ({
          id: editablePromocodesId && editablePromocodesId[index],
          name: promo.name,
          discount: parseInt(promo.discount.replace("%", "")) || 0,
          sorter: 0,
        } as PromoCodeData)),
    }));
  }, [promoCodes, setFormData, editablePromocodesId]);

  const addPromoCode = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const newPromoCodes = [...promoCodes, { name: "", discount: "0%" }];
    setPromoCodes(newPromoCodes);
    setButtonDisabled(newPromoCodes.length >= 3);
    setShowPromoCodes(true);
  };

  const removePromoCode = (index: number) => {
    if (promoCodes.length > 1) {
      const newPromoCodes = promoCodes.filter((_, i) => i !== index);
      setPromoCodes(newPromoCodes);
      setButtonDisabled(newPromoCodes.length >= 3);
    } else {
      // Если удаляем последний промокод, скрываем секцию
      setPromoCodes([]);
      setShowPromoCodes(false);
      setButtonDisabled(false);
    }
  };

  const handlePromoCodeChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const newPromoCodes = promoCodes.map((promo, i) => {
      if (i === index) {
        return {
          ...promo,
          [name]: name === "discount" ? formatDiscount(value) : value,
        };
      }
      return promo;
    });
    setPromoCodes(newPromoCodes);
  };

  const handleDecreaseDiscount = (index: number) => {
    const newPromoCodes = promoCodes.map((promo, i) => {
      if (i === index) {
        const newDiscount = Math.max(0, parseInt(promo.discount) - 1);
        return { ...promo, discount: `${newDiscount}%` };
      }
      return promo;
    });
    setPromoCodes(newPromoCodes);
  };

  const handleIncreaseDiscount = (index: number) => {
    const newPromoCodes = promoCodes.map((promo, i) => {
      if (i === index) {
        const currentDiscount = parseInt(promo.discount);
        const newDiscount = Math.min(100, currentDiscount + 1);
        return { ...promo, discount: `${newDiscount}%` };
      }
      return promo;
    });
    setPromoCodes(newPromoCodes);
  };

  const formatDiscount = (value: string) => {
    const numericValue = value.replace(/%/g, "");
    const parsedValue = isNaN(parseInt(numericValue, 10)) ? 0 : parseInt(numericValue, 10);
    const cappedValue = Math.min(parsedValue, 100);
    return `${cappedValue}%`;
  };

  return (
    <div className={s.promoSection}>
      <h2 className={s.sectionTitle}>Промокоды на событие</h2>
      {showPromoCodes && (
        <div className={s.buttonSectorMain}>
          <div className={s.buttonSector}>
            {promoCodes.map((promo, index) => (
              <div key={index} className={s.promoRow}>
                <div className={s.Promo}>
                  <label className={s.promoLabel}>Промокод</label>
                  <input
                    className={s.promoInputLeft}
                    name="name"
                    style={{ color: '#262429' }}
                    value={promo.name}
                    placeholder="СКИДКА10"
                    onChange={(event) => handlePromoCodeChange(index, event)}
                  />
                </div>
                <div className={s.PromoSell}>
                  <label className={s.promoLabel}>Скидка</label>
                  <div className={s.inputSect}>
                    <button
                      className={s.decreaseButton}
                      onClick={() => handleDecreaseDiscount(index)}
                    >
                      -
                    </button>
                    <input
                      className={s.promoInput}
                      name="discount"
                      value={promo.discount}
                      style={{ color: '#262429' }}
                      placeholder="10%"
                      onChange={(event) => handlePromoCodeChange(index, event)}
                    />
                    <button
                      className={s.increaseButton}
                      onClick={() => handleIncreaseDiscount(index)}
                    >
                      +
                    </button>
                  </div>
                </div>
                <button
                  className={s.delButton}
                  onClick={() => removePromoCode(index)}
                >
                  <img src={minus} alt="minus" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
      <button
        className={`${s.addButton} ${promoCodes.length >= 3 ? s.disabledButton : ''}`}
        onClick={addPromoCode}
        disabled={buttonDisabled || promoCodes.length >= 3}
      >
        Добавить промокод <img src={plus} alt="plus" />
      </button>
    </div>
  );
};
